export const enum BasketballKeyPeriod {
  FINISHED = 'finished',
  HALF_TIME_BREAK = 'halfTimeBreak',
  QUARTER_TIME_BREAK = 'quarterTimeBreak',
  QUARTER_PAUSE = 'quarterPause',
  TIME_BREAK = 'timeBreak',
  HALF_PERIOD = 'halfPeriod',
  TIMEOUT = 'timeout',
  OVERTIME_AND_PERIOD = 'overtimeAndPeriod',
}
